import React from "react"
import { injectIntl } from "react-intl"
import { useQuery } from "react-query"
import useListingPagination from "../../common/hooks/UseListingPagination"
import ListingWrapper from "../../common/listing/ListingWrapper"
import { ImportAdjusmentListingProps } from "../../common/types/inventory"
import IntlProps from "../../state/helpers/IntlProps"
import { AdjustmentService } from "../../state/inventory/adjustments/service/adjustmentservice"
import { getHeadersData, getRowCellsData } from "../../utils/inventory/importListingHelper"
import GlobalHelper from "../../common/GlobalHelper"


const ImportAdjustmentListing = (props: ImportAdjusmentListingProps & IntlProps) => {
    const importIdField = GlobalHelper.isEnvProduction() ? "importId.keyword" : "importId"

    const {
        paginatedSearch,
        handleSorting,
        updateTotalItemsCount,
        pagination,
    } = useListingPagination({
        keywords: "*",
        sortByField: "createdAt",
        sortAsc: true,
        pageSize: 25,
        activePage: 1,
        filters: {[importIdField]: props.importId},
    })

    const { error, isLoading, data: responseData } = useQuery(["findAdjustmentsByImportId", paginatedSearch], () => {
        return AdjustmentService.findAdjustmentsBySearchPayload(paginatedSearch)
    }, {
        onSuccess: (data) => {
            updateTotalItemsCount(data.metadata.totalItemsCount)
        }
    })


    const importAdjustments = responseData?.data || []
    const metadata = responseData?.metadata
    const totalItemsCount = metadata?.totalItemsCount || 0

    const headers = {
        data: getHeadersData(paginatedSearch.sortByField, paginatedSearch.sortAsc, handleSorting, props.intl),
        classNames: [],
    }

    const rows = importAdjustments?.map(importAdjustment => {
        return {
            rowId: importAdjustment.id,
            data: getRowCellsData(importAdjustment),
        }
    })

    const standardList = {
        className: "row pt-3",
        headers: headers,
        rows: rows,
        smallLine:true,
        pageSize: paginatedSearch.pageSize,
        totalItemsCount: totalItemsCount,
        showSelectionSize: false,
    }

    const search = <></>

   
    return <>
        <ListingWrapper
            isLoading={isLoading}
            error={error as Error}
            search={search}
            standardListProps={standardList}
            footer={pagination()}
        />
    </>
}

export default injectIntl(ImportAdjustmentListing)


// WEBPACK FOOTER //
// ./src/product/import/AdjustmentListing.tsx